import { ChangeEvent, SyntheticEvent, useMemo, useState } from "react";
import { clinicId, createdById } from "../../constants";
import usePopup from "../../hooks/usePopup";
import { Autocomplete, Button, Checkbox, CircularProgress,  debounce, Divider, IconButton, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import { saveUserGrpType, searchParamsType, UserListType } from "./type";
import { AddCircle, Close, Done, Edit } from "@mui/icons-material";
import { useQuery, useMutation } from "react-query";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import { deleteUserGrp, getAllUsergrp, saveUSergrp } from "./service";
import EmptyListAlert from "../../EMR/components/layouts/EmptyListAlert";

const index = () => {

    const pageTitle = "User group";
    const [changedStatus, setChangedStatus] = useState<number>(2);
    const [searchParams, setSearchParams] = useState<searchParamsType>({
        searchText: "",
        status: changedStatus,
        clinicId: clinicId,
        pageNumber: 0,
        pageSize: 25,
    });

    interface GroupListType extends UserListType {
    editmode: boolean;
}
    const [open, setOpen] = useState<boolean>(false);
    const [addorEdit, setAddorEdit] = useState<number>(0); // 0 for view, 1 for add, 2 for edit
    const [groupList, setGroupList] = useState<GroupListType[]>([]);
    const { CustomModal, showSnackbar } = usePopup();
    const { control, reset ,register,handleSubmit,getValues} = useForm()
    const {mutate:deleteData}=useMutation(deleteUserGrp,{
        onSuccess: (result) => {
            if (result.responseIndicator === "success") {
                refetch();
                setSelected({});
                setSelectedId(null);
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "success",
                    duration: 3000,
                });
            } else {
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "warning",
                    duration: 3000,
                });
            }
        },
        onError: (e: any) => {
            showSnackbar({
                message: e?.response?.data?.responseMessage || "Something went wrong !",
                open: true,
                variant: "error",
                duration: 3000,
            });
        },
    })

    const [selected, setSelected] = useState<{
        [key: number]: UserListType;
    }>({});
    const [selectedId, setSelectedId] = useState<number | null>(null)
    const {
        data: tableData,
        refetch,
    } = useQuery(
        ["", searchParams],
        async () => getAllUsergrp(searchParams),
        {
            refetchOnWindowFocus: false,
            onSuccess: (result) => {
                if (result.responseIndicator === "success") {
                    const items: GroupListType[] = result.response.items.map((item) => ({
                        ...item,
                        editmode: false
                    }));
                    setGroupList(items);
                } 
            }
        }
    );

    const { mutate: updateStatus, isLoading } = useMutation(saveUSergrp, {
        onSuccess: (result) => {
            if (result.responseIndicator == "success") {
                refetch();
                setSelected({});
                setSelectedId(null)
                setAddorEdit(0);
                setOpen(false);
                reset({
                    usergroup: "",
                    status: null
                })
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "success",
                    duration: 3000,
                });
            } else {
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "warning",
                    duration: 3000,
                });
            }
        },
        onError: (e: any) => {
            showSnackbar({
                message: e?.response?.data?.responseMessage || "Something went wrong !",
                open: true,
                variant: "error",
                duration: 3000,
            });
        },
    });




    const handleStatusChange = (
        _: SyntheticEvent,
        value: { label: string; value: number } | null
    ) => {
        setSearchParams((prev) => ({
            ...prev,
            status: value ? value.value : 3,
        }));
    };

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchParams((prev) => ({
            ...prev,
            searchText: e.target.value
        }));
    };
    
       const handleChangePage = (
        _: React.MouseEvent<HTMLButtonElement> | null,
        pageNumber: number
    ) => {
        setSearchParams((prev) => ({
            ...prev,
            pageNumber,
        }));
    };


      const handleChangeRowsPerPage = (
            event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
        ) => {
            setSearchParams((prev) => ({
                ...prev,
                page: 0,
                pageSize: parseInt(event.target.value, 10),
            }));
        };
    const debounceSearch = debounce(handleSearchChange, 500);



    const handleSelectAll: (e: ChangeEvent<HTMLInputElement>) => void = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            const objs: { [key: number]: UserListType } = {};
            tableData?.response?.items?.map(
                (item: UserListType, index: number) => {
                    objs[index] = item;
                }
            );
            setSelected(objs);
        } else {
            setSelected({});
        }
    };

    const handleSelect = (
        isChecked: boolean,
        item: UserListType,
        index: number
    ) => {
        if (isChecked) {
            setSelected((prev) => ({
                ...prev,
                [index]: item,
            }));
        } else {
            setSelected((prev) => {
                const newSelected = { ...prev };
                delete newSelected[index];
                return newSelected;
            });
        }
    };
    const handleOpenChangeStatus = () => {
        setOpen(true);
    };

    const handleCloseChangeStatus = () => {
        setOpen(false);
    };

    const handleUpdateStatus = () => {

        if (changedStatus == 2) {
            showSnackbar({
                message: "Please select a status !",
                open: true,
                variant: "warning",
                duration: 3000,
            });
        } else {
            const items: saveUserGrpType[] = [];
            for (let key in selected) {
                selected[key].status = changedStatus;

                items.push({
                    clinicId: clinicId,
                    createdById: createdById as number,
                    usergId: selected[key].id,
                    usergIp: "",
                    usergName: selected[key].usergName,
                    usergStatus: changedStatus
                });
            }
            updateStatus(items);
        }
    };

    const handleUpdateOneStatus = (
        status: boolean,
        data: UserListType
    ) => {
        setSelected({})
        setSelectedId(data.id);
        updateStatus([
            {
                clinicId: clinicId,
                createdById: createdById as number,
                usergId: data?.id,
                usergIp: "",
                usergName: data?.usergName,
                usergStatus: status ? 1 : 0

            }
        ]);
    };

    const handleEditClick = (data: UserListType,index:number) => {
                setGroupList((prev) => {
                    const updatedList = [...prev];
                    updatedList[index] = {
                        ...data,
                        editmode: true
                    };
                    return updatedList;
                });           
   
        reset({
            usergroup: data?.usergName
        })


    };

    const handleUpdate =(data:GroupListType)=>{
        const newUserGroup: saveUserGrpType = {
            clinicId: clinicId,
            createdById: createdById as number,
            usergId: data?.id, 
            usergIp: "",
            usergName: getValues(`remarks${data?.id}`) ,
            usergStatus: data.status  // Default to active if not specified
        };
        updateStatus([newUserGroup])

    }

    const handleSave = (data: any) => {
        console.log("data",data);
        
        const newUserGroup: saveUserGrpType = {
            clinicId: clinicId,
            createdById: createdById as number,
            usergId: 0, // Assuming new group has no ID yet
            usergIp: "",
            usergName: data.usergroup,
            usergStatus: data.status?.value?1: 0 // Default to active if not specified
        };
        updateStatus([newUserGroup])
    }

    


    const selectedSize = useMemo(() => {
        return Object.keys(selected).length;
    }, [selected]);

    return (
        <div className="p-3">
            <CustomModal
                open={open || (isLoading && Boolean(selectedSize > 0))}
                setOpen={setOpen}
                title={`Change status`}
                handleClose={handleCloseChangeStatus}
            >
                <div className="w-[50vw]">
                    <div className="max-h-[65vh] overflow-y-auto">
                        {Object.entries(selected).map(([key, item], index) => (
                            <div
                                key={`${index + key}`}
                                className="flex gap-2 ps-3 justify-start items-center py-2 overflow-y-auto"
                            >
                                <div className="h-[7px] w-[7px] bg-green-600 rounded m-2"></div>{" "}
                                <div>{`${item.usergName}${" - "}${item.id}`}</div>
                            </div>
                        ))}
                    </div>
                    <Divider />
                    <div className="flex justify-end items-center gap-2 p-3">
                        <Autocomplete
                            disableClearable
                            sx={{ width: "200px" }}
                            options={ChangeStatus}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                            }
                            renderInput={(params) => <TextField {...params} label="Status" />}
                            onChange={(_, value) => {
                                setChangedStatus(value?.value);
                            }}
                        />
                        <Button
                            disabled={isLoading}
                            endIcon={
                                isLoading && <CircularProgress size={20} color="success" />
                            }
                            color="success"
                            onClick={handleUpdateStatus}
                        >
                            Update
                        </Button>
                    </div>
                </div>
            </CustomModal>
            <Paper>
                <div className="flex justify-between p-3">
                    <div className="flex gap-2">
                        <Typography variant="h6" color={"default"}>
                            {pageTitle} Master
                        </Typography>
                    </div>

                </div>
                <Divider />
                <div className="">
                    <div className="grid grid-cols-4 gap-3 py-3 px-2">
                        <Autocomplete
                            disableClearable
                            fullWidth
                            options={status}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                            }
                            renderInput={(params) => <TextField {...params} label="Status" />}
                            onChange={handleStatusChange}
                        />
                        <TextField label={"Search"} onChange={debounceSearch} />
                    </div>
                    <TableContainer className="border">
                        {Boolean(selectedSize) && (
                            <div className="p-2">
                                <strong>Selected items {selectedSize}</strong>{" "}
                                <Button onClick={handleOpenChangeStatus}>Change Status</Button>
                            </div>
                        )}
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Checkbox
                                            checked={
                                                selectedSize == tableData?.response?.items?.length
                                            }
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    {headings.map((heading) => (
                                        <TableCell key={heading} className="font-bold">
                                            {heading}
                                        </TableCell>
                                    ))}
                                    <TableCell className="font-bold">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                          
                                {addorEdit === 1 && (
                                    <TableRow>
                                        <TableCell colSpan={1}>
                                            new User group
                                        </TableCell>
                                        <TableCell>
                                            <CustomFormField
                                                element="input"
                                                control={control}
                                                name="usergroup"
                                                rules={{ required: "User group is required" }}
                                                fieldProps={{ label: "User Group Name" }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <CustomFormField
                                                element="autocomplete"
                                                control={control}
                                                name="status"
                                                options={ChangeStatus}
                                                rules={{ required: "status is required" }}
                                                fieldProps={{ label: "Status" }}
                                                autocompleteProps={{
                                                    getOptionLabel: (option) => option?.label,
                                                    isOptionEqualToValue: (option, value) => option.value === value.value,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            {
                                            isLoading && (
                                                <CircularProgress size={18} />
                                            ) 
                                            }
                                            <IconButton onClick={()=>handleSubmit(handleSave)()} color="primary" type="submit">
                                                <Done />
                                            </IconButton>
                                            <IconButton onClick={()=> {
                                                setAddorEdit(0);
                                                reset({
                                                    usergroup: "",
                                                    status: null
                                                });
                                            } } color="error" type="submit">
                                                <Close />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )}

                               {addorEdit ===0 && 
                               <TableRow>
                                        <TableCell colSpan={5} >
                                            <EmptyListAlert alert="No user Groups" isData={Boolean(tableData?.response?.items?.length)} />
                                            <div className="flex items-center justify-end p-2">
                                                {!open && (
                                                    <Button
                                                        onClick={() => { setAddorEdit(1) }}
                                                        color="success"
                                                        endIcon={<AddCircle />}
                                                    >
                                                        add
                                                    </Button>
                                                )}
                                            </div>
                                        </TableCell>
                              </TableRow>  }
                                {groupList?.map((tableItem, index) => (
                                        <TableRow key={`${pageTitle}-${index}`}>
                                            <TableCell>
                                               {!tableItem?.editmode && <Checkbox
                                                    checked={Boolean(selected[index])}
                                                    onChange={(e) => {
                                                        handleSelect(e.target.checked, tableItem, index);
                                                    }}
                                                />}
                                            </TableCell>
                                            <TableCell>{tableItem?.editmode ?
                                                <TextField
                                                                       {...register(`remarks${tableItem?.id}`)} 
                                                                       label="Enter Remarks"
                                                                       variant="standard"
                                                                       defaultValue={tableItem?.usergName}
                                                                              />: tableItem?.usergName }
                                                </TableCell>
                                            <TableCell>
                                            <span
                                              className={`font-bold ${
                                                tableItem?.status ? "text-green-600" : "text-red-600"
                                              }`}
                                            >
                                              {tableItem?.status ? "Active" : "InActive"}
                                            </span>
                                          </TableCell>
                                            <TableCell>
                                                <div className="flex gap-2">
                                                   { tableItem?.editmode ?
                                                <>

                                                 {(isLoading && tableItem?.id === selectedId) && (
                                                        <span className="mt-2">
                                                            <CircularProgress size={18} />
                                                        </span>
                                                    )}
                                                       <IconButton
                                                            color="primary"
                                                            onClick={() => {
                                                               handleUpdate(tableItem)
                                                            }}>
                                                                <Done/>
                                                        </IconButton>
                                                        
                                                        
                                                        
                                                        <IconButton
                                                            color="error"
                                                            onClick={() => {
                                                               
                                                                setGroupList((prev) => {
                                                                    const updatedList = [...prev];
                                                                    updatedList[index] = {
                                                                        ...tableItem,
                                                                        editmode: false
                                                                    };
                                                                    return updatedList;
                                                                });
                                                            }}>
                                                            <Close /> 
                                                        </IconButton>
                                                </>
                                                :<>

                                                 <Switch
                                                        checked={Boolean(tableItem.status)}
                                                        disabled={isLoading && tableItem?.id === selectedId}
                                                        onChange={(e) => {
                                                            handleUpdateOneStatus(e.target.checked, tableItem);
                                                        }}
                                                    />
                                                     <IconButton
                                                            color="primary"
                                                            onClick={() => {
                                                                handleEditClick(tableItem,index);
                                                            }}
                                                        >
                                                            <Edit />
                                                        </IconButton>

                                                       <IconButton
                                                            color="error"
                                                            onClick={() => {
                                                                deleteData(tableItem?.id)
                                                            }}
                                                        >
                                                            <Close />
                                                        </IconButton> 
                                                </>
                                                    }
                                                    
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))  }
                            </TableBody>
                        </Table>
                         <div className="flex justify-end">
                       <TablePagination
                           rowsPerPageOptions={[5, 10, 25]}
                           component={"div"}
                           count={tableData?.response?.totalCount || 0}
                           rowsPerPage={searchParams.pageSize}
                           page={searchParams.pageNumber}
                           sx={{ border: 0 }}
                           slotProps={{
                               select: {
                                   inputProps: {
                                       "aria-label": "rows per page",
                                   },
                                   native: true,
                               },
                           }}
                           onPageChange={handleChangePage}
                           onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </div>
                    </TableContainer>
                </div>
            </Paper>
        </div>
    );

}

export default index

const status = [
    {label:"All",value:2},
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
];
const ChangeStatus=[
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 }
]

const headings = [
    "User Group Name",
    "status"
]